import { makeStyles, createStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      marginBottom: theme.spacing(1.25),
      height: 42,
      padding: `0 ${theme.spacing(2)}px`,

      '& > * + *': {
        marginLeft: theme.spacing(1),
      },
    },
    navigationButton: {
      textTransform: 'none',
    },
  }),
);
